/**
 * 錯誤碼 → 畫面文案的 i18n key（`<ns>.err_<code>`），依序試：原樣、大寫、小寫。
 * 錯誤碼一律 UPPER_SNAKE（SPEC #eng-10）；façade session 的 failure_code 與畫面自己的碼（no_recording_after…）是 lower_snake，
 * 同一種狀況兩種寫法要對得上同一句話。
 */
export function errorKeys(ns: string, code: string): string[] {
  return [...new Set([code, code.toUpperCase(), code.toLowerCase()].map((c) => `${ns}.err_${c}`))];
}
